<div [formGroup]="filedByForm">
    <p style="font-weight:bold">{{headerDeclareStmt}}</p>
    <p><label class="boldlbl">Filed By:</label></p>
    <div class="form-group row">
        <label for="filedby_last_name" class="col-md-3 col-form-label boldlbl"><span class="required">*</span>Last Name:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="filedby_last_name" name="filedby_last_name" formControlName="filedby_last_name"  [maxlength]="lastNameMaxLen">
            <span style="color: red;" *ngIf="filedby_last_name.errors?.required && filedby_last_name.touched">
                <span>Last name required.</span>
            </span>
        </div>
        <label for="filedby_first_name" class="col-md-2 col-form-label boldlbl"><span class="required">*</span>First
            Name:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="filedby_first_name" name="filedby_first_name" formControlName="filedby_first_name" [maxlength]="firstNameMaxLen">
            <span style="color: red;" *ngIf="filedby_first_name.errors?.required && filedby_first_name.touched">
                <span>First name required.</span>
            </span>
        </div>
        <label for="filedby_title" class="col-md-1 col-form-label boldlbl">Title:</label>
        <div class="col-md-2">
            <input class="form-control form-control-sm" type="text" id="filedby_title" name="filedby_title" formControlName="filedby_title" [maxlength]="titleMaxLen">
        </div>
    </div>
    <div class="form-group row">
        <label class="col-md-3 col-form-label boldlbl"><span class="required">*</span>Daytime Phone
            Number:</label>
        <div class="d-flex col-md-6">
            <span>(</span>
            <div class="col-md-4 spacing">
                <input #phArea class="form-control form-control-sm" type="text" id="filedby_phAreaCd" name="filedby_phAreaCd" formControlName="filedby_phAreaCd"
                    (input)="onInputEntry($event, phExch)" maxlength="3">
            </div>
            <span>)</span>
            <div class="col-md-4 spacing">
                <input #phExch class="form-control form-control-sm" type="text" id="filedby_phExchNbr" name="filedby_phExchNbr" formControlName="filedby_phExchNbr"
                    (input)="onInputEntry($event, phTrnk)" maxlength="3">
            </div>
            <span>-</span>
            <div class="col-md-4 spacing">
                <input #phTrnk class="form-control form-control-sm" type="text" id="filedby_phTrnkNbr" name="filedby_phTrnkNbr" formControlName="filedby_phTrnkNbr"
                    (input)="onInputEntry($event, phExt)" maxlength="4">
            </div>
        </div>
        <label for="filedby_phExtNbr" class="col-md-1 col-form-label boldlbl">ext.</label>
        <div class="col-md-2">
            <input #phExt class="form-control form-control-sm" type="text" formControlName="filedby_phExtNbr"
                [maxlength]="extMaxlength">
        </div>
    </div>
    <div class="row" style="margin-top: -15px!important;">
        <div class="col-md-9 offset-md-3">
            <span style="color: red;"
                *ngIf="(filedby_phAreaCd.errors?.required || filedby_phExchNbr.errors?.required || filedby_phTrnkNbr.errors?.required)&&(filedby_phAreaCd.touched || filedby_phExchNbr.touched || filedby_phTrnkNbr.touched)">
                <span class="form-text">{{errorMessages.phoneNbrReq}}</span>
            </span>
            <span style="color: red;"
                *ngIf="(filedby_phAreaCd.errors?.pattern || filedby_phExchNbr.errors?.pattern || filedby_phTrnkNbr.errors?.pattern) && (!filedby_phAreaCd.errors?.required && !filedby_phExchNbr.errors?.required && !filedby_phTrnkNbr.errors?.required)">
                <span class="form-text">{{errorMessages.phoneNbrError}}</span>
            </span>
        </div>
    </div>
    <div class="form-group row" style="margin-top: 15px!important;">
        <label for="filedby_email_addr" class="col-md-3 col-form-label boldlbl"><span class="required">*</span>E-mail
            Address:</label>
        <div class="col-md-9">
            <input class="form-control form-control-sm" type="text" id="filedby_email_addr" name="filedby_email_addr" formControlName="filedby_email_addr" maxlength="60">
            <span style="color: red;" *ngIf="filedby_email_addr.invalid && filedby_email_addr.touched">
                <span *ngIf="filedby_email_addr.errors?.required">Email address required.</span>
                <span class="form-text" *ngIf="filedby_email_addr.errors?.invalidAtDot">{{errorMessages.invalidAtDot}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidEmailChar">{{errorMessages.invalidEmailChar}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidEmailDomain">{{errorMessages.invalidEmailDomain}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidEmailUserName">{{errorMessages.invalidEmailUserName}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidEmailIp">{{errorMessages.invalidEmailIp}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidDomainName">{{errorMessages.invalidDomainName}}</span>
                <span *ngIf="filedby_email_addr.errors?.invalidDomainOrCountry">{{errorMessages.invalidDomainOrCountry}}</span>
                <span *ngIf="filedby_email_addr.errors?.missingEmailHost">{{errorMessages.missingEmailHost}}</span>
            </span>
        </div>
    </div>
    <div class="form-group row" *ngIf=" SDP == true ">
        <div class="col-md-2 offset-md-2">
            <div class="form-check">
                <input type="checkbox" class="form-check-input" id="filedby_tSDPPmt" name="filedby_tSDPPmt" formControlName="filedby_tSDPPmt">
                <label class="form-check-label boldlbl" for="tSDPPmt">SDP Payment</label>
            </div>
        </div>
    </div>
    <p style="font-style:italic" *ngIf=" footerDeclareStmt !='' ">{{footerDeclareStmt}}</p>
</div>